import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Per-environment A/V flags (owner kill-switches). Defaults mirror the backend
// so a failed fetch behaves exactly like a fresh environment.
const DEFAULTS = { av_track_recovery: true, av_leveler_off: true, av_ios_mix: false, av_ctx_48k: false, av_uplink_adapt: false, av_ios_light_encode: false, live_control_cell_v2: false };
const POLL_MS = 15000;

// Polled every 15 s (and on tab focus) so an owner kill-switch reaches rooms
// that are ALREADY live — previously flags were read once at join, so turning
// a flag off had no effect until the host rejoined.
export default function useAvFlags() {
  const [flags, setFlags] = useState(DEFAULTS);
  useEffect(() => {
    let on = true;
    const load = () => api.get("/feature-flags/public").then(({ data }) => {
      if (!on) return;
      const next = { ...DEFAULTS, ...(data?.flags || {}) };
      setFlags((prev) => (Object.keys(next).every((k) => prev[k] === next[k]) ? prev : next));
    }).catch(() => {});
    load();
    const t = setInterval(load, POLL_MS);
    const onVis = () => { if (document.visibilityState === "visible") load(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { on = false; clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, []);
  return flags;
}
